const en = {
    num: 'Num',
    operator: 'Operator',
    oprtTime: 'Operation time',
    oprtType: 'Operation type',
    orderSource: 'Order source',
    orderStatus: 'Order status',
    orderType: 'Order type',
    printCount: 'Print count',
    prdctName: 'Product Name',
    quantity: 'Quantity',
    delTip1: 'Are you sure you want to delete this {{type}} order?',
    delTip2: 'After deletion, the data on this {{type}} order cannot be recovered',
    delSucc: 'Delete successfully',
    delFail: 'Delete failed,{{content}}',
    orderDetails: 'Order details',
    cancel: 'Cancel',
    confirm: 'OK',
    confirm2: 'Confirm',
    basicData: 'Basic data',
    goods: 'Commodity',
    verificaFailed: 'Verification failed',
    quantityTip1: 'The quantity of goods must be greater than 0',
    quantityTip2: 'The product name and quantity format must be correct',
    aplicatForm: 'application Form',
    prdctList: 'Product List',
    fillQuantity: 'Please fill in the quantity of {{type}}',
    next: 'Next',
    noGood: 'The warehouse does not have the item in question',
    modificatFailed: 'Modification failed',
    tradeName: 'Trade name',
    brand: 'Model',
    desc: 'Describe',
    unit: 'Company',
    inboundOprt: 'Inbound',
    outboundOprt: 'Outbound',
    addFailed: 'Add failed',
    prdctSource: 'Product source',
    basicInfo: 'Basic information',
    creator: "Order Creator",
    createdAt: "Order Creation Time",
    preparedBy: 'Prepared By',
    preparationTime: 'Preparation Time',
    operationSource: 'Operation Source',
    operationStatus: 'Operation Status',
    inTransit: 'In Transit',
    inboundCompleted: 'Inbound Completed',
    preparing: 'Preparing',
    outboundCompleted: 'Outbound Completed',
    modifyFail: 'Failed to modify inventory',
    sameCodeTip1: 'Same barcode exists, please check',
    view: 'View',
    noScanOrder: 'Scan order does not exist',
    temStorage: 'Temporary save',
    repeatInTip: 'The barcode {{code}} already exists and cannot be stored again.',
    plFillInData: 'Please fill in the data',
    plFillInDataCompletely: 'Please fill in the data completely!',
    tip: 'Tips',
    cancelTip1: 'The current data already exists. Are you sure to cancel?',
    sameCodeSel: 'Duplicate barcode selection',
    sameCode: 'Duplicate barcode:',
    plSelSpecifiedProduct: 'Please select the specified product for operation:',
    productTitle: 'product',
    productCode: 'Product code',
    barcode: 'Bar code',
    viewCode: 'View barcode',
    copySuccess: 'Copy successful!',
    copyFail: 'Copy failed!',
    codeListWithCount: 'Storage barcode list (total: {{count}})',
    copyAll: 'Copy all',
    conDelTip1: 'There are duplicate barcodes in the warehouse. Do you want to delete the following barcodes?',
    conDelTip2: 'The barcode does not exist for the product in the warehouse. Do you want to delete the following barcode?',
    operationSucc: 'Operation successful',
    saveSucTip: 'Temporary storage successful, data can be manipulated in the order list!',
    saveFailTip: 'Temporary storage failed，{{err}}',
    fetchBarcodesFailt: 'Barcode query failed，{{err}}',
    searchPl: 'Please enter keywords to search',
    searchByOrderNumber: 'Please enter order number to search',
    startTime: 'Start Time',
    endTime: 'End Time',
    confirmTip: 'The following barcode does not match the item in the warehouse',
    serialMumber: 'SN',
    barcodesNumber: 'Barcode count',
    addDataTip: 'Please add data first',
    selectChangeTypePl: 'Please select the type of operation',
    preTime: 'Delivery time',
    confirmedTime: 'Actual in/out time',
    editOrder: 'Edit order',
    quantityConfirm: 'Quantity Confirm',
    updateOrderSuccess: 'Update order successfully',
    onOrders: 'Bulk ordering',
    ordersComfirm: 'Are you sure to place a bulk order?',
    optErr: "Operation failed",
    signed: 'Signed',
    noChanges: 'No changes',
    inOutNo: "In/Out Order",
    remark: 'Remark',
    saleOut: "Sales Outbound",
    calcOut: "Outbound Data Calculation",
    saledQty: "Sold Quantity",
    productionInCount: "Production Inbound Quantity",
    toSaledQty: "Pending Outbound Quantity",
    curSaledQty: "Current Sale Quantity",
    zeroTip: "At least one material must have a current sale quantity greater than 0",
    orderSucc: "Sales outbound order created successfully",
    orderErr: "Failed to create sales outbound order",
    preOut: "Allocate Stock",
    needPre: "Please allocate stock for the sales outbound order first!",
    preOutSucc: "Stock allocated successfully",
    preOutErr: "Stock allocation failed",
    orderContitle: "Confirm to create sales pre-outbound order?",
    outOvernum: "Used stock quantity exceeds available stock quantity",
    isSwap: "Is Transfer Order Document",
};
export default en;
